module.exports = __webpack_public_path__ + "img/printbillAd.8c64b526.jpg";